import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { deriveFeedView, type FeedView } from '../lib/feed';
import { useLive } from '../store/live';
import { useNow } from './useNow';

export function useBackendUp(): boolean {
  const health = useQuery({
    queryKey: ['health-live'],
    queryFn: () => api.get<{ status: string }>('/health/live'),
    refetchInterval: 10_000,
    retry: 1,
  });
  return !health.isError;
}

export function useFeedView(): FeedView {
  const provider = useLive((s) => s.provider);
  const connection = useLive((s) => s.connections.market);
  const quoteReceivedAt = useLive((s) => s.quoteReceivedAt);
  const backendUp = useBackendUp();
  const now = useNow(1000);
  return deriveFeedView(provider, connection, quoteReceivedAt, now, backendUp);
}
